import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { update_payment_path } from '@routes';
import { AddPaymentMethodParams, addPaymentMethod } from '@utils/backend-api/stripe';
import { ADD_PAYMENT_METHOD_FALLBACK_ERROR } from '@utils/stripePaymentError';

const useAddPaymentMethod = () => {
  const { mutate, isLoading, isError } = useMutation(
    (params: AddPaymentMethodParams = {}) => addPaymentMethod(params),
    {
      onSuccess: (data) => {
        window.location.href = data.redirect_to;
      },
      onError: (error: { message?: string; redirect_to?: string }) => {
        toast.error(error?.message || ADD_PAYMENT_METHOD_FALLBACK_ERROR);
        window.location.href = error?.redirect_to || update_payment_path();
      },
    }
  );
  return { mutate, isLoading, isError };
};

export default useAddPaymentMethod;
